import actions from "../../constants/actions";

const initialState = {
    data: [],
    isLoading: false,
    error: null,
};

export default function lessons(state = initialState, action) {
    switch (action.type) {
        case actions.LESSONS.LOAD_LIST:
            return { ...state, isLoading: true };
        case actions.LESSONS.LOAD_LIST_SUCCESS:
            const mySet = new Set([
                ...state.data,
                ...action.payload.result.data,
            ]);
            return {
                ...state,
                data: [...mySet],
                isLoading: false,
                error: null,
            };
        case actions.LESSONS.LOAD_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case actions.LESSONS.LOAD:
            return { ...state, isLoading: true };
        case actions.LESSONS.LOAD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                errorMessage: "",
            };
        case actions.LESSONS.LOAD_FAIL:
            return {
                ...state,
                isLoading: false,
                errorMessage: action.payload,
            };
        default:
            return state;
    }
}
